<script setup lang="ts">
  import InputDateQC from '@qicgroupdoha/qic-connect-ds/components/InputDateQC'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import { useI18n } from 'vue-i18n'

  interface Props {
    modelValue: Date | null
    errors?: string[]
    isValid: boolean
    passportMinDate: Date
    loading: boolean
    disabled?: boolean
  }

  const { locale } = useI18n()
  defineProps<Props>()
  defineEmits<{ (e: 'update:modelValue', value: Date | null): void }>()
</script>

<template>
  <WrapperQC direction="column">
    <!-- @vue-ignore -->
    <InputDateQC
      :model-value="modelValue"
      :label="$t('qlm_passport_exp')"
      :min-date="passportMinDate"
      :errors="errors"
      :calendar-props="{ startDate: modelValue ?? passportMinDate }"
      :input-props="{
        isValid,
        disabled,
        containerAttrs: { 'data-test': 'passport-expiry-date-input' },
        name: 'passportExpiryDate',
        loading,
      }"
      :locale="locale"
      :disabled="disabled"
      :max-date="new Date('2070-01-01')"
      allow-manual-input
      data-test="passport-expiry-date-input-inner"
      @update:model-value="$emit('update:modelValue', $event)"
    />
  </WrapperQC>
</template>
